<template>
  <div>
    <modal
      :show.sync="docPreview"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      hide-footer
      size="lg"
      bodyClasses=""
      @close="close"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Topic Preview
      </h6>

      <div>
        <iframe
          class="screenht450 w-full -mt-4"
          :src="$imageURL + '/' + docData.file + '#toolbar=0'"
          frameborder="0"
          height="500"
          width="100%"
        ></iframe>
      </div>
      <template slot="footer">
        <!-- <base-button type="primary">SAVE CHANGES</base-button>
        <base-button
          @click="TopicPreview = false"
          type="secondary"
          class="ml-auto"
          >CLOSE</base-button
        > -->
        <div class="hidden">helo</div>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    docPreview: Boolean,

    docData: Object,
  },
  methods: {
    close() {
      this.$emit("close-docPreview");
    },
  },
};
</script>
